export const ADD_SCANNED_TICKET = 'src/Scan/ADD_SCANNED_TICKET';
export const CLEAR_SCANNED_TICKETS = 'src/Scan/CLEAR_SCANNED_TICKETS';
export const LOADING = 'src/Scan/LOADING'
export const FETCH_SCANNED_TICKETS = 'src/Scan/FETCH_SCANNED_TICKETS';
export const SHOW_SCAN_MODAL_WITH_DETAILS = 'src/Scan/SHOW_SCAN_MODAL_WITH_DETAILS';
export const FETCH_TICKET_DETAILS = 'src/Scan/FETCH_TICKET_DETAILS';
export const SET_CODE_TO_SCAN = 'src/Scan/SET_CODE_TO_SCAN';
